import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { aboutInfo } from '@/mocks/about';

export default function Footer() {
  return (
    <footer className="bg-secondary-950">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="font-heading text-lg font-semibold text-background-50 mb-4">
              私密健康指南
            </h4>
            <p className="text-sm text-foreground-300 leading-relaxed">
              {aboutInfo.tagline}
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-medium text-background-50 mb-4">
              内容分类
            </h4>
            <ul className="flex flex-col gap-2">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-300 transition-colors whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-medium text-background-50 mb-4">
              热门文章
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/article/yindao-yan-zhonglei" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors whitespace-nowrap">
                  阴道炎的种类与区别
                </Link>
              </li>
              <li>
                <Link to="/article/fenmiwu-yichang-panduan" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors whitespace-nowrap">
                  分泌物异常判断指南
                </Link>
              </li>
              <li>
                <Link to="/article/si-chu-qingjie-zhengque" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors whitespace-nowrap">
                  私处清洁的正确方法
                </Link>
              </li>
              <li>
                <Link to="/article/fuke-jiancha-xiangmu" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors whitespace-nowrap">
                  妇科检查项目全解读
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-medium text-background-50 mb-4">
              关于我们
            </h4>
            <ul className="flex flex-col gap-2">
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-300 transition-colors whitespace-nowrap">
                  品牌介绍
                </Link>
              </li>
              <li>
                <span className="text-sm text-foreground-300">
                  联系邮箱：{aboutInfo.contact.email}
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-foreground-700/30 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 女性私密健康指南 版权所有
          </p>
          <p className="text-xs text-foreground-400">
            本站内容仅供参考，不能替代专业医疗诊断和治疗
          </p>
        </div>
      </div>
    </footer>
  );
}